import React from 'react';
import { Link } from 'react-router-dom';
import { SourceSystem, REFUND_PATH_2, NEW_DATE_TIME_FORMAT } from '@atlassian/cssxp-typescommon';
import { GloballyAllowedSidebar } from '@atlassian/cssxp-utils-generic';
import { FormattedDate, formattedV2, NoDataContentInTable, OpenSidebarRow } from '@css-xp/base';
import { Refunds } from '@css-xp/graphtypes';
import { InvoiceRefundStatusLozenge } from './invoice-refund-status-lozenge';
import { InvoiceRefundCreditNote } from './invoice-refund-creditnote-lozenge';
import NoteIcon from '@atlaskit/icon/glyph/editor/note';
import classNames from 'classnames';
import { isInvoiceRefunded } from '@atlassian/cssxp-utils-invoice';
import { Refund } from '@atlassian/cssxp-types-billing';

interface Props {
  parentColumns: number;
  nextColumns?: number;
  key: string;
  refund: Refunds;
  hideActions?: boolean;
  isSelected: boolean;
  index?: number;
  isCloudSiteInvoiceTab?: boolean;
  refundDetailsLink?: string | undefined;
  shouldDisableSidebar?: boolean;
  isInvoiceSearch?: boolean;
}

export function InvoiceChildRefundRow(props: Props) {
  const {
    refund,
    parentColumns,
    hideActions,
    isSelected,
    nextColumns = 1,
    index,
    isCloudSiteInvoiceTab,
    refundDetailsLink,
    shouldDisableSidebar = false,
    isInvoiceSearch = false,
  } = props;
  let greyRow = false;
  let whiteRow = false;

  if (index || index === 0) {
    greyRow = index % 2 !== 0;
    whiteRow = index % 2 === 0;
  }
  const getRefundCells = () => {
    return (
      <>
        <td className="id col-auto" data-testid="refund-id">
          <Link
            to={refundDetailsLink ?? `${REFUND_PATH_2}/${encodeURIComponent(refund.creditNoteNumber || refund.id)}`}
            onClick={(e) => e.stopPropagation()}
            className="avatar-container"
          >
            <span className="invoice-refund-slug-cell">
              <NoteIcon label="Filter" /> {refund.creditNoteNumber || refund.id}
            </span>
          </Link>
          <div>
            {!isInvoiceRefunded(refund as Refund) && (
              <span className="pl-8">{<InvoiceRefundStatusLozenge status={'PENDING'} />}</span>
            )}
            {refund?.type !== 'full-item-refund' && (
              <>
                {refund?.type && <span className="pl-8">{<InvoiceRefundCreditNote credittype={refund.type} />}</span>}
              </>
            )}
          </div>
        </td>
        {isCloudSiteInvoiceTab ? (
          <td colSpan={parentColumns - nextColumns - 2}></td>
        ) : (
          <td colSpan={parentColumns - nextColumns - 3}></td>
        )}
        <td>
          {refund.createdDate ? (
            <FormattedDate date={refund.createdDate} showTime={true} format={NEW_DATE_TIME_FORMAT} />
          ) : (
            <NoDataContentInTable />
          )}
        </td>
        <td colSpan={parentColumns - nextColumns - 5}></td>
        {isInvoiceSearch && <td colSpan={parentColumns - nextColumns - 5}></td>}
        <td className="invoice-amount-cell" data-testid="refund-amount">
          {refund.total ? (
            <>
              - <formattedV2.FormattedCurrencyV2 value={refund.total} currency={refund.currency} showCurrencyCode />
            </>
          ) : null}
        </td>
      </>
    );
  };

  return (
    <>
      {isSelected || shouldDisableSidebar ? (
        <tr
          key={refund.id}
          className={classNames({
            'grey-row': greyRow,
            'white-row': whiteRow,
            'border-top': true,
          })}
          data-testid="refund-normal-row"
        >
          {getRefundCells()}
        </tr>
      ) : (
        <OpenSidebarRow
          key={refund.id}
          className={classNames({
            'grey-row': greyRow,
            'white-row': whiteRow,
            'border-top': true,
          })}
          sidebar={GloballyAllowedSidebar.REFUND_PREVIEW}
          payload={{
            refundId: refund.creditNoteNumber || refund.id,
          }}
          sidebarOptions={{
            isOverlay: true,
            sidebarWidth: '600px',
          }}
          isSelected={isSelected}
          hasDefaultClassName={false}
        >
          {getRefundCells()}
        </OpenSidebarRow>
      )}
    </>
  );
}

export default InvoiceChildRefundRow;
